import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { ScreenFlowFormButtons } from "./ScreenFlowFormButtons";
import { objectVals2String } from "../../../utils/objectVals2String";

interface Values {
  answer: string;
  followUpAnswer: string;
}

export type SelectOption = {
  value: string;
  label?: string;
};

interface Props {
  initAnswer?: string;
  initMoreAnswer?: string;
  answerLabel?: string;
  errorText?: string;
  options: SelectOption[];
  onComplete: (answer: string, followUpAnswer?: string) => Promise<boolean>;
  onBack?: () => void;
  centerButtons?: boolean;
  helpContent?: string | JSX.Element;
}

export const SingleSelectOptionForm = ({
  initAnswer,
  initMoreAnswer,
  answerLabel,
  errorText,
  options,
  onComplete,
  onBack,
  centerButtons,
  helpContent,
}: Props): JSX.Element => {
  // const { setHelpContent } = useContext(AppContext);

  // const optionsRequiringFollowUp: string[] = [];
  // options.forEach((option: SelectOption) => {
  //   option.followUp && optionsRequiringFollowUp.push(option.value);
  // });

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      answer: initAnswer || "",
      followUpAnswer: initMoreAnswer || "",
    },
    schema: Yup.object().shape({
      answer: Yup.string().required(errorText || `${answerLabel} is required`),
      // followUpAnswer: Yup.string().when("answer", (answer) => {
      //   return optionsRequiringFollowUp.length &&
      //     optionsRequiringFollowUp.includes(answer)
      //     ? Yup.string().required()
      //     : Yup.string();
      // }),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      await onComplete(values.answer, values.followUpAnswer);
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={formikInit.values}
      validationSchema={formikInit.schema}
      onSubmit={handleSubmit}
      // force re-render by effectively subscribing to specific value
      key={objectVals2String(formikInit.values)}
    >
      {({
        errors,
        handleChange,
        // handleBlur,
        handleSubmit,
        isSubmitting,
        // touched,
        values,
        status,
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid
            container
            spacing={1}
            sx={{
              my: 1,
            }}
          >
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id={`${answerLabel}-label`}>
                  {answerLabel}
                </InputLabel>
                <Select
                  labelId={`${answerLabel}-label`}
                  id={`${answerLabel}-id`}
                  aria-label={answerLabel}
                  name="answer"
                  value={values.answer}
                  // onBlur={handleBlur}
                  onChange={handleChange}
                >
                  {options.map((option: SelectOption) => (
                    <MenuItem
                      value={option.value}
                      key={`${answerLabel}-${option.value}`}
                    >
                      {option.label || option.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.answer && (
                <Typography
                  variant="body1"
                  color="error"
                  sx={{
                    my: 2,
                  }}
                >
                  {errors.answer}
                </Typography>
              )}
              {helpContent &&
                (typeof helpContent === "string" ? (
                  <Typography
                    variant="caption"
                    sx={{
                      ml: 2,
                    }}
                  >
                    {helpContent}
                  </Typography>
                ) : (
                  helpContent
                ))}
            </Grid>
            <Grid item xs={12}>
              <ScreenFlowFormButtons
                isSubmitting={isSubmitting}
                status={status}
                onBack={onBack}
                centered={centerButtons}
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};
